import { render, staticRenderFns } from "./RowspanTable.vue?vue&type=template&id=5bae6168&scoped=true&"
import script from "./RowspanTable.vue?vue&type=script&lang=js&"
export * from "./RowspanTable.vue?vue&type=script&lang=js&"
import style0 from "./RowspanTable.vue?vue&type=style&index=0&id=5bae6168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae6168",
  null
  
)

export default component.exports